import React, { useEffect, useRef } from 'react';
import { Workspace } from './types';

interface PortletWorkspacePopoverProps {
  portletId: string;
  workspaces: Workspace[];
  portletWorkspaceIds: string[];
  onToggle: (workspaceId: string, portletId: string) => void;
  anchorEl: HTMLElement;
  onClose: () => void;
}

const PortletWorkspacePopover: React.FC<PortletWorkspacePopoverProps> = ({
  portletId,
  workspaces,
  portletWorkspaceIds,
  onToggle,
  anchorEl,
  onClose,
}) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Position near the anchor
  const rect = anchorEl.getBoundingClientRect();
  const style: React.CSSProperties = {};

  // Try to position to the left of the anchor
  if (rect.left > 240) {
    style.top = rect.top;
    style.left = rect.left - 230;
  } else {
    // Position below if not enough space on the left
    style.top = rect.bottom + 4;
    style.left = Math.max(8, rect.left - 100);
  }

  // Prevent going off-screen bottom
  if ((style.top as number) + 300 > window.innerHeight) {
    style.top = window.innerHeight - 310;
  }

  const nonAllAppsWorkspaces = workspaces.filter((w) => !w.isAllApps);

  return (
    <div className="workspace-popover" style={style} ref={popoverRef}>
      <div className="workspace-popover-header">Add to workspace</div>
      {nonAllAppsWorkspaces.map((ws) => {
        const isChecked = portletWorkspaceIds.includes(ws.id);
        return (
          <button
            key={ws.id}
            className="workspace-popover-item"
            onClick={() => onToggle(ws.id, portletId)}
          >
            <span className={`workspace-popover-check ${isChecked ? 'checked' : ''}`}>
              {isChecked ? '✓' : ''}
            </span>
            <span className="workspace-popover-ws-icon">{ws.icon}</span>
            <span className="workspace-popover-ws-name">{ws.name}</span>
          </button>
        );
      })}
      {nonAllAppsWorkspaces.length === 0 && (
        <div style={{ padding: '12px 16px', color: '#a19f9d', fontSize: '13px' }}>
          No workspaces yet. Create one first.
        </div>
      )}
    </div>
  );
};

export default PortletWorkspacePopover;
